import styles from "./foods.css";
import React, {useContext, useState, useRef, useEffect} from "react";
import foodsText from "../../assets/foods.json";
import TextsContext from "../../TextsContent";
import {useNavigate, useLocation} from "react-router-dom";

const Foods = () => {
  const foodsArr = foodsText.categories;
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(null);
  const [itemClasses, setItemClasses] = useState({});
  const [isAnimating, setIsAnimating] = useState(false);
  const [extraPadding, setExtraPadding] = useState(false); // Стан для додаткового падінгу
  const {activeCategory} = location.state || {};

  const selectedFood = foodsArr.find(
    (item) => item.name === activeCategory
  ).items;

  const navigate = useNavigate();
  const texts = useContext(TextsContext);
  const itemRefs = useRef({});
  const timers = useRef({});
  const timerFadeIn = useRef(null);
  const foodRef = useRef(null);


  useEffect(() => {
    window.scrollTo({top: 0, behavior: 'smooth'});

    if (foodRef.current) {
      foodRef.current.classList.add('food-fade-in');
    }

    timerFadeIn.current = setTimeout(() => {
      foodRef.current.classList.remove('food-fade-in');
    }, 350);

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);

  const openItem = (name, isLastOrSecondLast) => {
    setItemClasses((prevClasses) => ({
      ...prevClasses,
      [name]: "active",
    }));

    // Додаємо затримку перед скролом
    setTimeout(() => {
      if (itemRefs.current[name]) {
        const element = itemRefs.current[name];
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

        const yOffset = -100; // Відступ 100 пікселів
        const yPosition =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({
          top: yPosition,
          behavior: "smooth",
        });
      }
    }, 100);

    // Встановлюємо додатковий падінг, якщо це останній або передостанній елемент
    setExtraPadding(isLastOrSecondLast);
  };

  const closeItem = (name) => {
    setItemClasses((prevClasses) => ({
      ...prevClasses,
      [name]: "active deactivate",
    }));

    timers.current[name] = setTimeout(() => {
      setItemClasses((prevClasses) => ({
        ...prevClasses,
        [name]: "",
      }));
      setIsAnimating(false);
    }, 700);
  };

  const handleItemClick = (name, isLastOrSecondLast) => {
    if (isAnimating) return;

    setIsAnimating(true);

    if (activeItem === name) {
      closeItem(name);
      setActiveItem(null);
      setExtraPadding(false); // Скидаємо падінг, якщо закриваємо елемент
    } else {
      if (activeItem) {
        closeItem(activeItem);
      }
      setTimeout(() => {
        openItem(name, isLastOrSecondLast);
        setActiveItem(name);
        setIsAnimating(false);
      }, 700);
    }
  };

  return (
    <div ref={foodRef}
         className="main-container food">
      <div className="outer-content foods">
        <img
          loading="lazy"
          className="main-logo"
          src={require("./img/food_image.png")}
          alt="logo"
        />
        <p className="main-text">{texts.food}</p>
        <div className="site-title">
          <img
            className="main-logo"
            loading="lazy"
            src={require("./img/logo_text.png")}
          />
        </div>
      </div>
      <div
        className={`inner-content foods ${extraPadding ? "padding-extra" : ""}`}
      >
        <div className="workout-navigation">
          <img
            className="workout-navigation__arrow"
            onClick={() => navigate(-1)}
            src={require("../../assets/img/back_arrow.svg").default}
            width="24"
            height="24"
            alt="image arrow left"
          />
        </div>
        {selectedFood.map((item, index) => {
          const itemClass = itemClasses[item.name] || "";
          const isLastOrSecondLast = index >= selectedFood.length - 2; // Останній або передостанній елемент

          return (
            <div
              key={item.name}
              ref={(el) => (itemRefs.current[item.name] = el)}
              className={`menu-item menu-item--foods ${itemClass}`}
              onClick={() => handleItemClick(item.name, isLastOrSecondLast)}
            >
              <div className="menu-text__wrapper">
                <div className="menu-item__icon">
                  <img
                    loading="lazy"
                    className="menu-item__image"
                    src={require(`${item.mainImage}`)}
                    alt="icon"
                  />
                </div>
                <h2 className="menu-item__title food">{item.name}</h2>
              </div>

              {itemClass.includes("active") && (
                <div className="ingredients-list">
                  {item.ingredients &&
                    item.ingredients.map((ingredient, index) => (
                      <div key={index} className="ingredient-box">
                        <img
                          loading="lazy"
                          className="ingredient-image"
                          src={require(`${ingredient.image}`)}
                          alt={`${ingredient.name} icon`}
                        />
                        <div className="ingredient-name">{ingredient.name}</div>
                        <span className="ingredient-amount">
                          {ingredient.amount}
                        </span>
                      </div>
                    ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Foods;
